import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

import { useStatus } from "@/api/statuses";
import { Popover, Spinner, Stack, Text } from "@/components/ui";
import { useIsTouchDevice } from "@/hooks";

import Status from "../status";

import type { Status as StatusProps } from "@/schemas";

interface StatusPopoverProps {
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  isEnabled?: boolean;
  status: Pick<StatusProps, "id">;
}

const StatusPopover = (props: StatusPopoverProps) => {
  const {
    children,
    isEnabled = true,
    status: { id },
  } = props;

  const isTouchDevice = useIsTouchDevice();

  const [isOpen, setIsOpen] = useState(false);
  const { status, isLoading, isLoadingError } = useStatus(id, {
    refetch: true,
    isEnabled: isEnabled && isOpen,
  });

  const renderStatus = () => {
    if (isLoadingError) {
      return (
        <Text theme="muted" className="p-4" align="center">
          <FormattedMessage
            id="statuses.tombstone"
            defaultMessage="This Truth is unavailable."
          />
        </Text>
      );
    }

    if (isLoading || !status) {
      return <Spinner />;
    }

    return <Status status={status} hoverable={false} hideActionBar muted />;
  };

  if (!isEnabled) {
    return children;
  }

  return (
    <Popover
      interaction={isTouchDevice ? "click" : "hover"}
      referenceElementClassName="cursor-pointer"
      onOpen={() => setIsOpen(true)}
      content={
        <Stack space={4} className="relative isolate w-96 overflow-hidden">
          {renderStatus()}
        </Stack>
      }
      isFlush
      children={<div className="inline-block max-w-full">{children}</div>}
    />
  );
};

export default StatusPopover;
